import {createContext} from "react";

const SituacaoContext = createContext({});

export default SituacaoContext;